import React from 'react'
import { DYNAMIC_URL_REGEX } from '../../../../constants'
import { Box, Typography } from '@mui/material';

export default function MediaWithDynamicURL({ url, style }) {
    return (
        <>
            {url?.match(DYNAMIC_URL_REGEX) ? (
                <Box style={{ ...style, backgroundColor: "#0d59b091", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant='h6' color={"white"}>
                        Variable
                    </Typography>
                </Box>
            ) : (
                <img src={url} style={style} />
            )}
        </>
    );
}
